/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Empty_Library_BodyInputs */



/**
* | output |
* | --- |
* | "As soon as your organisation adds practice conversations, you will find them here." |
*
* @param {Practice_Empty_Library_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_empty_library_body = /** @type {((inputs?: Practice_Empty_Library_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Empty_Library_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Zodra je organisatie oefengesprekken klaarzet, vind je ze hier.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dès que votre organisation en propose, vous les trouverez ici.")
	return /** @type {LocalizedString} */ ("As soon as your organisation adds practice conversations, you will find them here.")
});